import { TableBody, TableCell, TableRow } from '@/components/ui/table'
import SkeletonLoader from './SkeletonLoader'

/**
 * Generic table row skeleton component for loading states
 * Shows shimmer animation for table rows while data is being fetched
 */
const TableRowSkeleton = ({ 
    rows = 3, 
    showIcon = true, 
    showCheckbox = true,
    iconCount = 1,
    columns = 3 
}) => {
    return (
        <TableBody>
            {Array.from({ length: rows }).map((_, index) => (
                <TableRow 
                    key={index} 
                    className="tw:cursor-pointer hover:tw:bg-gray-700/20"
                    style={{ borderBottom: index === rows - 1 ? '0px solid transparent' : undefined }}
                >
                    {/* First column - typically contains checkbox, icon(s), and label */}
                    <TableCell>
                        <div className="tw:flex tw:items-center tw:gap-3">
                            {showCheckbox && (
                                <SkeletonLoader width="16px" height="16px" borderRadius="4px" />
                            )}
                            {showIcon && Array.from({ length: iconCount }).map((_, iconIndex) => (
                                <SkeletonLoader 
                                    key={iconIndex}
                                    width="20px" 
                                    height="20px" 
                                    borderRadius="4px" 
                                />
                            ))}
                            <SkeletonLoader width="80px" height="16px" borderRadius="4px" />
                        </div>
                    </TableCell>
                    
                    {/* Additional columns - typically right-aligned data */}
                    {Array.from({ length: columns - 1 }).map((_, colIndex) => (
                        <TableCell key={colIndex} className="tw:text-right">
                            <div className="tw:flex tw:justify-end">
                                <SkeletonLoader 
                                    width={colIndex === 0 ? "70px" : "40px"} 
                                    height="16px" 
                                    borderRadius="4px" 
                                />
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    )
}

export default TableRowSkeleton